import React from 'react';
import { CloseButton, UnstyledButton } from '@mantine/core';
import FilterSurface from '../Filter.Surface';

type Props = {
    name: string;
    operator: string;
    value: string;
    title: string;
    excluded?: boolean;
    dot?: string;
    onRemove: () => void;
    children: (close: () => void) => React.ReactNode;
};

const FilterChip: React.FC<Props> = ({ name, operator, value, title, excluded = false, dot, onRemove, children }) => {
    const [opened, setOpened] = React.useState(false);
    const close = () => setOpened(false);

    const target = (
        <span className="bd-fc" data-excluded={excluded || undefined} data-open={opened || undefined}>
            <UnstyledButton
                className="bd-fc-body"
                onClick={() => setOpened((current) => !current)}
                aria-label={`Modifica il filtro ${name}: ${operator} ${value}`}
                aria-expanded={opened}
                aria-haspopup="dialog"
                title={title}
            >
                <span className="bd-fc-key">{name}</span>
                <span className="bd-fc-op">{operator}</span>
                {dot ? <span className="bd-fc-dot" style={{ backgroundColor: dot }} aria-hidden /> : null}
                <span className="bd-fc-value">{value}</span>
            </UnstyledButton>
            <CloseButton className="bd-fc-remove" size="sm" onClick={onRemove} aria-label={`Togli il filtro ${name}`} />
        </span>
    );

    return (
        <FilterSurface opened={opened} onClose={close} target={target} label={`Filtro ${name}`}>
            {children(close)}
        </FilterSurface>
    );
};

export default FilterChip;
